import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer style={{
      display:"flex", 
      flexDirection:"row", 
      gap:20, 
      width:"100%",
      height:"5%", 
      marginTop:20, 
      //marginBottom:20,
      alignItems:"center",
      justifyContent:"space-evenly",
      backgroundColor:"white"
    }}>
    {/* className="card footer container" style={{marginTop:28, display:'block', width:"100%", flexWrap:'wrap'}}> */}
      <div>
        <div style={{fontWeight:700}}>Professional Services</div>
        <div className="kv">Vetted professionals • Secure</div>
      </div>

      <div className="kv">© {new Date().getFullYear()} Professional Services</div>

      <div style={{display:'flex', gap:12}}>
        <Link className="kv" to="/terms">Terms</Link>
        <Link className="kv" to="/privacy">Privacy</Link>
      </div>
    </footer>
  )
}
